export default __webpack_public_path__ + "static/media/KZ.T.03.1616.a5ceb0d3.svg";